import { useMemo } from 'react';

import { filtersSchema } from 'scenes/RegsStats/schemas';

const useIsValidFilters = (filters) => {
  return useMemo(() => {
    return filtersSchema.isValidSync(filters);
  }, [filters]);
};

export default useIsValidFilters;
